import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import axios from '@utils/request'
import { IOneSessionPayload } from '@app-store/slices/sessions/oneSession'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: IOneSessionPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sessions.oneSession

function* oneSessionSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/event/session/one/${payload.sessionId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneSessionSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneSessionSagaTask)
}

export default oneSessionSaga
